<template>
    <div class="container-docu-sign">
        <section class="sign-required">
            <span class="sign-required-header">
                Assinaturas Requeridas
            </span>
        
            <span class="sign-required-configuration-default">
                Configure o padrão de assinatura para os contratos informando os tipos de usuários
                seus respectivos papeis no fluxo de assinatura.
            </span>
        </section>

        <section class="container-marker-paper-signers">
            <div class="marker-paper-signers">
                <section class="content-marker-paper-signers">
                    <div class="signers">
                        <span>Assinantes</span>
                    </div>

                    <div class="maker-paper">
                        <span class="paper">Papel</span>

                        <span class="maker">Marcador - Nome</span>

                        <span class="maker">Marcador - Assinatura/Aprovador</span>

                        <span class="all-pages">Assinatura obrigatória</span>
                    </div>
                </section>

                <section v-for="(signer, index) in signers" :key="index" class="news-signers">
                    <div class="news-signers-items">
                        <div class="action-checkbox">
                            <ui-checkbox
                                v-model="signer.selected"
                                design="mgb-0"
                                :checked="signer.selected"
                                :disabled="signer.type === 'customer'"
                            />

                            <div class="text-signers">
                                <span>{{ signer.label }}</span>

                                <span v-if="signer.type === 'nonuser'" class="director">
                                    ({{ signer.name }} - {{ signer.email }})
                                </span>
                            </div>
                        </div>

                        <div class="action-select-input">
                            <div class="action-select">
                                <ui-select-v2
                                    v-model="signer.role"
                                    return-value="value"
                                    background-color="#FFF"
                                    design="mgb-0"
                                    size="md"
                                    :data="roleOptions"
                                    :error="!!formValidation.errors[signer.group]?.role"
                                    :observation="formValidation.errors[signer.group]?.role"
                                    @input="roleHandler(signer)"
                                />
                            </div>

                            <div class="action-input">
                                <ui-input
                                    v-if="signer.type === 'nonuser'"
                                    v-model="signer.keyword.name"
                                    size="mgb-0 md"
                                    background-color="#FFF"
                                    :error="!!formValidation.errors[signer.group]?.['keyword.name']"
                                    :observation="formValidation.errors[signer.group]?.['keyword.name']"
                                    @input="keywordHandler($event, signer)"
                                />

                                <span v-else class="signer-name-text">
                                    {{ signer.keyword?.name || '-' }}
                                </span>
                            </div>

                            <div class="action-input">
                                <span class="signer-name-text">
                                    {{ signer.keyword?.sign || signer.keyword?.approve || '-' }}
                                </span>
                            </div>

                            <div class="action-switch">
                                <ui-switch
                                    v-model="signer.optional"
                                    :checked="!signer?.optional"
                                    design="sm mgb-0"
                                    :value-true="false"
                                    :value-false="true"
                                />
                            </div>


                            <div v-if="signer.type === 'nonuser'" class="action-menu-card">
                                <ui-menu-card icon="far fa-ellipsis-v">
                                    <ui-button @click="edit(signer)">
                                        Configurações
                                    </ui-button>

                                    <ui-button @click="removeSigner(index)">
                                        Excluir
                                    </ui-button>
                                </ui-menu-card>
                            </div>
                        </div>
                    </div>

                    <div v-if="hasErrors(signer)" class="errors-list">
                        <ul>
                            <li
                                v-for="(error, index) in formValidation.errors[signer.group]"
                                :key="index"
                            >
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                </section>
            </div>

            <div class="add-new-signers">
                <span class="new-signers" @click="addSigner">
                    + Adicionar novo assinante
                </span>
            </div>
        </section>

        <section class="footer-docu-sign">
            <div class="envelope-status">
                <div class="envelope-status-add">
                    <span class="text-status">Status do Envelope</span>

                    <span class="text-select">Selecione o status que você deseja criar os envelopes. </span>
                </div>

                <div class="envelope-status-select">
                    <ui-select-v2
                        v-model="envelopeAttributes.status"
                        :data="statusOptions"
                        return-value="value"
                        size="lg"
                    />
                </div>
            </div>

            <div class="save-editions">
                <ui-button
                    :disabled="!canSubmit"
                    design="primary mw-150 md"
                    @click="save">
                    Salvar Alterações
                </ui-button>
            </div>
        </section>

        <ui-add-signers-modal />
        <ui-integration-modal />
    </div>
</template>

<script>
    import { uiSelectV2, uiCheckbox, uiInput, uiSwitch } from '@/components/ui/form'
    import { uiMenuCard } from '@/components/ui'
    import { uiButton } from '@/components/ui/buttons'
    import { uiAddSignersModal } from '@/components/ui-facilita/products'
    import uiIntegrationModal from './components/integration-modal'

    import { mapActions, mapGetters } from 'vuex'

    import { utilMixin, helpersMixin } from '@/mixins'
    import { $mx_generateSignerKeyword } from '@/mixins/helpers'

    import { docuRoles as roles, status } from '@/assets/js/data'

    export default {
        name: 'ui-docu-sign',

        components: {
            uiSelectV2,
            uiCheckbox,
            uiInput,
            uiMenuCard,
            uiButton,
            uiAddSignersModal,
            uiIntegrationModal,
            uiSwitch
        },

        mixins: [utilMixin, helpersMixin],

        data() {
            return {
                createContract: false,
                envelopeAttributes: {
                    status: '',
                    email_subject: ''
                },
                statusOptions: [...status],
                roleOptions: [...roles],
                unsubscribe: null,
                interval: null
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                signers: 'getSigners',
                envelope: 'getEnvelope',
                formValidation: 'getFormValidation'
            }),
            /**
             * Computed property que verifica se a configuração de Assinantes possui todas as
             * informações necessárias
             */
            canSubmit() {
                return this.formValidation?.valid && this.envelopeAttributes.status
            }
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe(mutation => {
                if (mutation.type === 'digitalSignatureStore/SET_ENVELOPE' &&
                    this.envelope) {
                    this.envelopeAttributes = { ...this.envelope }
                }
            })
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
                'setSigners',
                'setEnvelope',
                'saveConfigs',
                'removeSigner'
            ]),
            /**
             * Abre o modal para o cadastro de assinantes externos
             */
			addSigner() {
				this.$root.$emit('modal-open-docu_sign-add-signers')
			},
            /**
             * Abre o modal para edição de um assinante externo
             */
            edit(signer) {
                this.$root.$emit('modal-open-docu_sign-add-signers', signer)
            },
            /**
             * Solicita o salvamento e registro dos dados de um envelop e seus
             * assinantes
             */
            save() {
                this.setEnvelope(this.envelopeAttributes)
                this.saveConfigs()
            },
            /**
             * Verifica se existem erros de formulário referentes a determinado assinante
             */
            hasErrors(signer) {
                return Object.keys(this.formValidation.errors[signer.group] || {}).length
            },
            /**
             * Event handler que recebe um assinante e define suas macros/marcadores
             */
            keywordHandler(value, signer) {
                clearInterval(this.interval)
                this.interval = setInterval(() => {
                    clearInterval(this.interval)
                    this.interval = null
                    signer.keyword = $mx_generateSignerKeyword(value, signer.role)
                }, 2000)
                this.setSigners(this.signers)
            },
            /**
             * Event handler que trata o evento de quando a função de um assinante é selecionada
             * para alterar suas macros
             */
            roleHandler(signer) {
                signer.keyword = $mx_generateSignerKeyword(signer.keyword.name, signer.role)
                this.setSigners(this.signers)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>